import type { v2, ControlTypeFunction } from '@sap/ux-specification-types';
import { ControlType } from '@sap/ux-specification-types';
import { syncRule, buildControlIdFromParent } from '../../../common/decoration';
import {
    addPatternForBindingChangeOfEnumOP,
    getActionBreadcrumbParts,
    convertActionKeyToStableId
} from '../../../common';
import type { ButtonType } from 'sap/m/library';
import type { URI } from 'sap/ui/core/library';

/**
 * Create stable ID for Object Page Footer Action button.
 *
 * @param baseId Base Id of the control
 * @param idBreadcrumbs Array of breadcrumbs used for generating the ID
 * @param breadcrumbs Array of breadcrumbs representing the action path
 * @param controlType Function to determine the control type
 * @returns stable ID of Object Page Footer Action button
 */
const getFooterActionButtonId = (
    baseId: string,
    idBreadcrumbs: string[],
    breadcrumbs: string[],
    controlType: ControlTypeFunction
): string => {
    if (controlType() === ControlType.Button) {
        const { actionId } = getActionBreadcrumbParts(breadcrumbs);
        return `${baseId}action::${convertActionKeyToStableId(actionId)}::Determining`;
    }
    return buildControlIdFromParent(baseId, idBreadcrumbs);
};

const flexRuleForFooterAction = {
    controlId: getFooterActionButtonId,
    controlType: (): ControlType => ControlType.Button
};

export class ObjectPageFooterAction implements v2.ObjectPageFooterAction {
    @syncRule({
        flex: flexRuleForFooterAction,
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible: boolean;

    @syncRule({
        flex: flexRuleForFooterAction
    })
    tooltip?: string;

    @syncRule({
        flex: flexRuleForFooterAction
    })
    icon?: URI;

    @syncRule({
        flex: flexRuleForFooterAction
    })
    activeIcon?: URI;

    @syncRule({
        flex: flexRuleForFooterAction
    })
    type?: ButtonType;
}
